/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getEmbedExternalView.defs'
export { main as default } from './getEmbedExternalView.defs'
